import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

function Merke(props) {
    const useStyles = makeStyles((theme) => ({
        merke: {
            backgroundColor: theme.palette.type === 'dark' ? theme.palette.merke.dark : theme.palette.merke.light,
            padding: '6px',
        },
    }));
    const classes = useStyles();
    return <div className={classes.merke}>
        <u><b>Merke:</b></u>
        <br />
        {props.content}
    </div>;
}

export default Merke;